import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-garage-developer-guide/ibm-garage-developer-guide/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Globals from 'gatsby-theme-carbon/src/templates/Globals';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`Deploy an Artificial Intelligence Microservice`}</p>
    </PageDescription>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Prerequisites`}</p>
        <ul parentName="li">
          <li parentName="ul">{`The instructor should `}<a parentName="li" {...{
              "href": "/dev-guide/workshop/setup"
            }}>{`Setup Workshop Environment`}</a></li>
          <li parentName="ul">{`The student should `}<a parentName="li" {...{
              "href": "/dev-guide/workshop/terminal"
            }}>{`Setup CLI and Terminal Shell`}</a></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Instructor will provide the following info:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`OpenShift Console URL (OCP_CONSOLE_URL)`}</li>
          <li parentName="ul">{`The username and password for OpenShift and Git Server (default values are user01, user02, etc.. for users and `}<inlineCode parentName="li">{`password`}</inlineCode>{` for password).`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_USERNAME`}</inlineCode>{` environment variable.
If you are participation in a workshop replace `}<inlineCode parentName="p">{`userdemo`}</inlineCode>{` with your assigned username (ex. `}<inlineCode parentName="p">{`user01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_USERNAME=userdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login to OpenShift using `}<inlineCode parentName="p">{`oc`}</inlineCode></p>
        <ul parentName="li">
          <li parentName="ul">{`If using IBM Cloud cluster then login with your IBM account email and IAM API Key or Token by using the `}<strong parentName="li">{`Copy Login Command`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "439px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "46.18055555555556%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAFu2jAiPB//xAAZEAACAwEAAAAAAAAAAAAAAAAAAwEEFCD/2gAIAQEAAQUCwKIpqgyK4//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAIBBQAAAAAAAAAAAAAAAAABEQIgMTKR/9oACAEBAAY/As1EQ2avtn//xAAaEAEAAQUAAAAAAAAAAAAAAAABEABBgdHx/9oACAEBAAE/IemaoPJLLLx//9oADAMBAAIAAwAAABBwL//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAEDAQE/EEf/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxBX/8QAGxAAAgMAAwAAAAAAAAAAAAAAESEAARAxgaH/2gAIAQEAAT8QYZBz13yPBDsPbLx//9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Login",
                "title": "Login",
                "src": "/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/88c5d/login.jpg",
                "srcSet": ["/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/69549/login.jpg 288w", "/dev-guide/static/75b1c2097aefc07605cbecf798f7c126/88c5d/login.jpg 439w"],
                "sizes": "(max-width: 439px) 100vw, 439px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`If using a cluster that was configured with the workshop scripts outside IBM Cloud then use respective assigned username (ex. `}<inlineCode parentName="li">{`user01`}</inlineCode>{`), and the password is `}<inlineCode parentName="li">{`password`}</inlineCode></li>
        </ul>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc login $OCP_URL -u $TOOLKIT_USERNAME -p password
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set `}<inlineCode parentName="p">{`TOOLKIT_PROJECT`}</inlineCode>{` environment variable
If you are participation in a workshop replace `}<inlineCode parentName="p">{`projectdemo`}</inlineCode>{` based on your assigned username (ex. `}<inlineCode parentName="p">{`project01`}</inlineCode>{`).`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`TOOLKIT_PROJECT=projectdemo
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a project/namespace using your project as prefix, and `}<inlineCode parentName="p">{`-dev`}</inlineCode>{` and suffix`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc sync $TOOLKIT_PROJECT-dev
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Fork application template git repo`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open Developer Dashboard from the OpenShift Console
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "242px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "210.3305785123967%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAqABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIBBQP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABV1qXkuqJ9VELJLRrB//EABwQAAMAAQUAAAAAAAAAAAAAAAABEhUCBBAgQf/aAAgBAQABBQLHmOHsWUWWiVU6SUerldf/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQEv/aAAgBAwEBPwGHLKyvf//EABYRAAMAAAAAAAAAAAAAAAAAAAARIP/aAAgBAgEBPwEc/wD/xAAgEAABAgUFAAAAAAAAAAAAAAAAEDEBAiAzQSGhotHh/9oACAEBAAY/Armxc4mk4wyR6GGPVwYp/8QAIRAAAgEDAwUAAAAAAAAAAAAAAREAITFBYYHhECBRcfD/2gAIAQEAAT8hBoOrK5wVX/PcfoHZQgayBV0UagiYAqNJNPCAyvmLOX0KyKvMR0Gzt//aAAwDAQACAAMAAAAQoOgBcw//xAAYEQADAQEAAAAAAAAAAAAAAAAAEWEQQf/aAAgBAwEBPxBh3ChTf//EABYRAAMAAAAAAAAAAAAAAAAAAAARIP/aAAgBAgEBPxAaf//EACEQAQADAAICAQUAAAAAAAAAAAEAESExUXGBQZGhscHR/9oACAEBAAE/ELU5URaD1fKZcq3YENVRv6rYVoi8uX94ECHhP7FYa6qYPxKNHruDB+KIvJ6gksqqWKzr4maNjfDCwdQ9wDeOtXOeI+C+W19JjxBe5b3Fe2f/2Q==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Developer Dashboard",
                "title": "Developer Dashboard",
                "src": "/dev-guide/static/56711b1107d51727d965fb2c84f861bb/9f65a/developer-dashboard.jpg",
                "srcSet": ["/dev-guide/static/56711b1107d51727d965fb2c84f861bb/9f65a/developer-dashboard.jpg 242w"],
                "sizes": "(max-width: 242px) 100vw, 242px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`Select Starter Kits
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "53.81944444444444%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAEDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHac0WJC//EABkQAAMAAwAAAAAAAAAAAAAAAAABEQIQMf/aAAgBAQABBQKoqFHpmPP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAbEAACAwADAAAAAAAAAAAAAAAAAREhMWGBsf/aAAgBAQABPyGKbOY1IatmOj2P/9oADAMBAAIAAwAAABDj3//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxBlf//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQACAgMBAAAAAAAAAAAAAAEAIRExQVFhgf/aAAgBAQABPxARRThqXa6zqAEBu24HLb37AZt/UVo//9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Starter Kits",
                "title": "Starter Kits",
                "src": "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/2e753/starter-kits-ai.jpg",
                "srcSet": ["/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/69549/starter-kits-ai.jpg 288w", "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/473e3/starter-kits-ai.jpg 576w", "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/2e753/starter-kits-ai.jpg 1152w", "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/74f4b/starter-kits-ai.jpg 1728w", "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/de5bb/starter-kits-ai.jpg 2304w", "/dev-guide/static/a7fd58f547b30856792c14d19701dbc9/5559a/starter-kits-ai.jpg 2950w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`Select One in our case `}<strong parentName="li">{`Artificial Intelligence Microservice`}</strong></li>
          <li parentName="ul">{`Click Fork`}</li>
          <li parentName="ul">{`Login into GIT Sever using the provided username and password (ie `}<inlineCode parentName="li">{`userdemo`}</inlineCode>{` and `}<inlineCode parentName="li">{`password`}</inlineCode>{`)`}</li>
          <li parentName="ul">{`Click `}<strong parentName="li">{`Fork Repository`}</strong></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Setup environment variable `}<inlineCode parentName="p">{`GIT_URL`}</inlineCode>{` for the git url using the value from previous step or as following.
`}<strong parentName="p">{`Note:`}</strong>{` We are including username/password in git url for simplicity of this lab. You would `}<strong parentName="p">{`NOT`}</strong>{` want to do this in your development environment.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`GIT_REPO=ai-model-object-detector
GIT_URL=http://\${TOOLKIT_USERNAME}:password@$(oc get route -n tools gogs --template='{{.spec.host}}')/\${TOOLKIT_USERNAME}/\${GIT_REPO}
echo GIT_URL=\${GIT_URL}

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Clone the git repository and change directory`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`cd $HOME
git clone $GIT_URL app
cd app

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a Tekton pipeline for the application`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`oc pipeline --tekton
`}</code></pre>
        <ul parentName="li">
          <li parentName="ul">{`Use down/up arrow and select `}<inlineCode parentName="li">{`ibm-general`}</inlineCode></li>
          <li parentName="ul">{`Enter `}<strong parentName="li">{`n`}</strong>{` and hit Enter to disable image scanning`}</li>
          <li parentName="ul">{`Hit Enter to enable Dockerfile linting`}</li>
          <li parentName="ul">{`Hit Enter to select default health endpoint `}<inlineCode parentName="li">{`/`}</inlineCode></li>
          <li parentName="ul">{`Open the url to see the pipeline running in the OpenShift Console`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that Pipeline Run completed successfully`}</p>
        <ul parentName="li">
          <li parentName="ul">{`On the OpenShift web console select `}<strong parentName="li">{`Pipelines`}</strong></li>
          <li parentName="ul">{`At the top of the page select your development project/namespace created above (ex. `}<inlineCode parentName="li">{`project01-dev`}</inlineCode>{`)`}</li>
          <li parentName="ul">{`The app pipeline last run status should be `}<strong parentName="li">{`Succeeded`}</strong>
            <span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "39.23611111111111%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAIABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAEDBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAbdgJB//xAAYEAACAwAAAAAAAAAAAAAAAAAAEQEFIf/aAAgBAQABBQKvjEI//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGBAAAgMAAAAAAAAAAAAAAAAAADEBAnH/2gAIAQEABj8CvooEf//EABkQAQACAwAAAAAAAAAAAAAAAAEAERAhUf/aAAgBAQABPyEW8NDApxP/2gAMAwEAAgADAAAAEPAP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAGhAAAgIDAAAAAAAAAAAAAAAAAREA8SExcf/aAAgBAQABPxBuYoNFYMIjRu1K2f/Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Pipeline Run",
                "title": "Pipeline Run",
                "src": "/dev-guide/static/2f88293d23ce5bdf15a5c1f1201f667e/2e753/pipeline-run.jpg",
                "srcSet": ["/dev-guide/static/2f88293d23ce5bdf15a5c1f1201f667e/69549/pipeline-run.jpg 288w", "/dev-guide/static/2f88293d23ce5bdf15a5c1f1201f667e/473e3/pipeline-run.jpg 576w", "/dev-guide/static/2f88293d23ce5bdf15a5c1f1201f667e/2e753/pipeline-run.jpg 1152w", "/dev-guide/static/2f88293d23ce5bdf15a5c1f1201f667e/36980/pipeline-run.jpg 1478w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Review the Pipeline Tasks/Stages.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Click on the last run
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "8.680555555555555%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAACABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAEDBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEA/9oADAMBAAIQAxAAAAHagKwJ/8QAFhABAQEAAAAAAAAAAAAAAAAAARAy/9oACAEBAAEFAnZP/8QAFREBAQAAAAAAAAAAAAAAAAAAARD/2gAIAQMBAT8BZ//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAABD/2gAIAQEABj8Cf//EABYQAQEBAAAAAAAAAAAAAAAAAAAxAf/aAAgBAQABPyGC21//2gAMAwEAAgADAAAAEPw//8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQMBAT8Qg//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABkQAQEBAAMAAAAAAAAAAAAAAAERADGx4f/aAAgBAQABPxBs6yHbmrFZ7ubf/9k=')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Last pipeline run",
                "title": "Last pipeline run",
                "src": "/dev-guide/static/a91bdc907f990ebec7ece6570c52aac6/2e753/last-run.jpg",
                "srcSet": ["/dev-guide/static/a91bdc907f990ebec7ece6570c52aac6/69549/last-run.jpg 288w", "/dev-guide/static/a91bdc907f990ebec7ece6570c52aac6/473e3/last-run.jpg 576w", "/dev-guide/static/a91bdc907f990ebec7ece6570c52aac6/2e753/last-run.jpg 1152w", "/dev-guide/static/a91bdc907f990ebec7ece6570c52aac6/57afb/last-run.jpg 1188w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`Click on the `}<strong parentName="li">{`Test`}</strong>{` task and view the logs
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "5.208333333333334%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAABABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAIF/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEAMQAAAB2LAD/8QAFRABAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQEAAQUCp//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAEDAQE/AWf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAVEAEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAQAGPwJv/8QAFRABAQAAAAAAAAAAAAAAAAAAARD/2gAIAQEAAT8hLf/aAAwDAQACAAMAAAAQhA//xAAVEQEBAAAAAAAAAAAAAAAAAAAQMf/aAAgBAwEBPxCj/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAFxABAQEBAAAAAAAAAAAAAAAAAAExof/aAAgBAQABPxDki6j/2Q==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "Test task",
                "title": "Test task",
                "src": "/dev-guide/static/ba0508a2b9056a11b5014d206654bfda/2e753/test-task.jpg",
                "srcSet": ["/dev-guide/static/ba0508a2b9056a11b5014d206654bfda/69549/test-task.jpg 288w", "/dev-guide/static/ba0508a2b9056a11b5014d206654bfda/473e3/test-task.jpg 576w", "/dev-guide/static/ba0508a2b9056a11b5014d206654bfda/2e753/test-task.jpg 1152w", "/dev-guide/static/ba0508a2b9056a11b5014d206654bfda/69502/test-task.jpg 1301w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
          <li parentName="ul">{`Open SonarQube from Console Link`}</li>
          <li parentName="ul">{`Open Registry from Console Link`}</li>
          <li parentName="ul">{`Open Artifactory from Console Link`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The `}<strong parentName="p">{`gitops`}</strong>{` step of the pipeline triggeres Argo CD to deploy the app to QA. Select `}<strong parentName="p">{`Developer`}</strong>{` perspective, select project `}<inlineCode parentName="p">{`$TOOLKIT_PROJECT-qa`}</inlineCode>{` and then select `}<strong parentName="p">{`Topology`}</strong>{` from the Console and verify the application running
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1088px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.43055555555556%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIGA//EABUBAQEAAAAAAAAAAAAAAAAAAAAC/9oADAMBAAIQAxAAAAHKgn6EQQV//8QAGhAAAgIDAAAAAAAAAAAAAAAAAAQBEBIhNP/aAAgBAQABBQJLbBlAj0V//8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BR//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABUQAQEAAAAAAAAAAAAAAAAAABCB/9oACAEBAAY/Aox//8QAGhAAAgMBAQAAAAAAAAAAAAAAAREQITEAsf/aAAgBAQABPyEmBDcAzTqs71z/AP/aAAwDAQACAAMAAAAQw8//xAAWEQADAAAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8QtEh//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHBABAAICAwEAAAAAAAAAAAAAAQAxESEQUXHw/9oACAEBAAE/ECQxevXcAKA8mALZlTcs+64bZ//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Last pipeline run",
              "title": "Last pipeline run",
              "src": "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/c3319/deploy-qa.jpg",
              "srcSet": ["/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/69549/deploy-qa.jpg 288w", "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/473e3/deploy-qa.jpg 576w", "/dev-guide/static/6c6ef7ad5b561db429ed4c62070aa67c/c3319/deploy-qa.jpg 1088w"],
              "sizes": "(max-width: 1088px) 100vw, 1088px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Open the application route url and try out the application using the swagger UI or append `}<inlineCode parentName="p">{`/app`}</inlineCode>{` to the URL to load Web UI for the Application. You can download the this sample `}<a parentName="p" {...{
            "href": "https://raw.githubusercontent.com/IBM/MAX-Object-Detector/master/samples/baby-bear.jpg"
          }}>{`picture`}</a>{` to test the app
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "261px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "86.59003831417625%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAARABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAexnvQiuAAP/xAAaEAACAwEBAAAAAAAAAAAAAAABAgADESAh/9oACAEBAAEFAi2R2ulZsKsukec//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAgEBPwEf/8QAGxAAAQQDAAAAAAAAAAAAAAAAAQACEWETICP/2gAIAQEABj8CQxtbFroADW//xAAbEAADAQEAAwAAAAAAAAAAAAABESEAMSBBYf/aAAgBAQABPyF5ANdz5HJW94wuZ8ZDDemYEQ8f/9oADAMBAAIAAwAAABBIAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAWEQEBAQAAAAAAAAAAAAAAAAARASD/2gAIAQIBAT8QoY//xAAdEAEAAgMAAwEAAAAAAAAAAAABESEAMUEgUbHw/9oACAEBAAE/EJmaEpWu8Hn3GIku4DEbMaJNAq0h23vAQUqJBGqf3vBHUeP/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "open url",
              "title": "open url",
              "src": "/dev-guide/static/5233473c5ddd7f0516fe68c4abeda71c/319fc/open-url.jpg",
              "srcSet": ["/dev-guide/static/5233473c5ddd7f0516fe68c4abeda71c/319fc/open-url.jpg 261w"],
              "sizes": "(max-width: 261px) 100vw, 261px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
`}<span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "47.56944444444444%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAKABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAUBAgP/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB1bLmUXJK/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAIDEyEyQf/aAAgBAQABBQK6QTKHE0P/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAEAAQUAAAAAAAAAAAAAAAABEAARITFx/9oACAEBAAY/AsBQu7Scj//EABoQAAIDAQEAAAAAAAAAAAAAAAERABAhMaH/2gAIAQEAAT8hKwgVuRulA4q+FX//2gAMAwEAAgADAAAAEPgP/8QAFREBAQAAAAAAAAAAAAAAAAAAERD/2gAIAQMBAT8QCf/EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/ECf/xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhURCRsfD/2gAIAQEAAT8QObmxU094lXqertMwAAGCPifE1x//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "ai app",
              "title": "ai app",
              "src": "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/2e753/ai-app-baby-bear.jpg",
              "srcSet": ["/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/69549/ai-app-baby-bear.jpg 288w", "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/473e3/ai-app-baby-bear.jpg 576w", "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/2e753/ai-app-baby-bear.jpg 1152w", "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/74f4b/ai-app-baby-bear.jpg 1728w", "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/de5bb/ai-app-baby-bear.jpg 2304w", "/dev-guide/static/74a4382f8dd807417e1d648bc8e9bd11/82815/ai-app-baby-bear.jpg 2826w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span></p>
      </li>
    </ol>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Make a change to the application in the git repository and see the pipeline running again from the Console. Lets chagne the Machine Learning being used from `}<inlineCode parentName="p">{`ssd_mobilenet_v1`}</inlineCode>{` to `}<inlineCode parentName="p">{`faster_rcnn_resnet101`}</inlineCode></p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git config --local user.email "\${TOOLKIT_USERNAME}@example.com"
git config --local user.name "\${TOOLKIT_USERNAME}"
sed -i 's/ssd_mobilenet_v1/faster_rcnn_resnet101/' Dockerfile
git add .
git commit -m "update model"
git push -u origin master

`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that change in Git Server and Git WebHook`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open Git Dev from Console Link`}</li>
          <li parentName="ul">{`Navigate to user app git repository`}</li>
          <li parentName="ul">{`Review the recent commit`}</li>
          <li parentName="ul">{`Review the webhook recent delivery
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1018px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "45.138888888888886%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAECBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAd0bJLD/xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAEFAl//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAaEAACAgMAAAAAAAAAAAAAAAAAARBRESFB/9oACAEBAAE/IeGXRukKf//aAAwDAQACAAMAAAAQcA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAABBAMBAAAAAAAAAAAAAAABABEhMRBhgZH/2gAIAQEAAT8QEOAeadbPqAMkmyJVe5//2Q==')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "webhood",
                "title": "webhood",
                "src": "/dev-guide/static/2455effa64faf9253e3d2a1890745fa0/ca5a3/webhook.jpg",
                "srcSet": ["/dev-guide/static/2455effa64faf9253e3d2a1890745fa0/69549/webhook.jpg 288w", "/dev-guide/static/2455effa64faf9253e3d2a1890745fa0/473e3/webhook.jpg 576w", "/dev-guide/static/2455effa64faf9253e3d2a1890745fa0/ca5a3/webhook.jpg 1018w"],
                "sizes": "(max-width: 1018px) 100vw, 1018px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that a new Pipeline starts successfully`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Verify that the App manifests are being updated in the `}<inlineCode parentName="p">{`gitops`}</inlineCode>{` repo in the git account `}<inlineCode parentName="p">{`toolkit`}</inlineCode>{` under the `}<inlineCode parentName="p">{`qa`}</inlineCode>{` directory.`}</p>
        <ul parentName="li">
          <li parentName="ul">{`Open Git Ops from Console Link`}</li>
          <li parentName="ul">{`Select toolkit/gitops git repository
`}<span parentName="li" {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "45.833333333333336%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAJABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAECBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHdbCShP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEAAQUCX//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEABj8CX//EABgQAAIDAAAAAAAAAAAAAAAAABAgITFh/9oACAEBAAE/IaE4n//aAAwDAQACAAMAAAAQUD//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAgEBPxBX/8QAHRAAAgIBBQAAAAAAAAAAAAAAAREAMUEQIVFhgf/aAAgBAQABPxAMGVeIN+YA5efcNewVp//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "gitops",
                "title": "gitops",
                "src": "/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/2e753/gitops.jpg",
                "srcSet": ["/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/69549/gitops.jpg 288w", "/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/473e3/gitops.jpg 576w", "/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/2e753/gitops.jpg 1152w", "/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/74f4b/gitops.jpg 1728w", "/dev-guide/static/60418f3829e9a5c09373f1353c166eb1/1b112/gitops.jpg 2078w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy"
              }}></img>{`
    `}</span></li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Congratulations you finished this lab, continue with lab `}<a parentName="p" {...{
            "href": "./cd"
          }}>{`Promote an Application using CD with GitOps and ArgoCD`}</a></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      